import { useAutomations } from "sdk/command-palette/queries"

export const PAGE_ID = "automation-search"

export const SHORTCUT = "f a"

const SEARCH_ENTRY_COMMAND = {
  id: "search-automations",
  label: "Search Visual Automations…",
  icon: "search",
  group: "Search",
  keywords: ["find", "automation", "visual automation", "workflow", "funnel"],
  shortcut: SHORTCUT,
  onSelect: api => api.pushPage(PAGE_ID)
}

/**
 * Provider for visual automation search. At the root it offers the "Search
 * automations…" entry that opens the subpage. Like tags, segments, and
 * sequences, the whole list is small and changes rarely, so we preload it once
 * when the subpage opens and let cmdk filter it client-side (the subpage sets
 * `shouldFilter: true`). Selecting an automation opens it in the editor.
 *
 * @type {import("../types").Provider}
 */
export function useAutomationSearchProvider({ activePageId }) {
  const active = activePageId === PAGE_ID

  const { data, isFetching } = useAutomations({ enabled: active })

  // Root: offer the entry point into the subpage.
  if (!activePageId) {
    return { commands: [SEARCH_ENTRY_COMMAND], isLoading: false }
  }

  // A different subpage owns the list.
  if (!active) return { commands: [], isLoading: false }

  const commands = (data?.automations ?? []).map(automation => ({
    id: `automation-${automation.id}`,
    label: automation.name,
    icon: "share",
    group: "Visual Automations",
    onSelect: api => api.navigate(`/automations/${automation.id}/edit`)
  }))

  return { commands, isLoading: isFetching }
}

/**
 * @returns {import("../types").Shortcut[]}
 */
export function getAutomationSearchShortcuts() {
  return [{ shortcut: SHORTCUT, onTrigger: api => api.pushPage(PAGE_ID) }]
}
